<workspace-object-viewer class="main-panel" [workspace]="workspace$ | async" [object]="object$ | async"
    [insightId]="insightId$ | async">
</workspace-object-viewer>
